import type {
  GetStaticPaths,
  GetStaticPropsContext,
  InferGetStaticPropsType
} from 'next'

/* blocks */
import Layout from '@/cmp/templates/Layout/Layout'
import CaseStudyIndividualPages from '@/cmp/templates/CaseStudy/CaseStudyIndividualPages'

/* utils */
import { getStrapiGraphqlData } from '@/utils/api/wrapper'
import {
  INSTANT_REVALIDATION,
  TEN_MINS_REVALIDATION
} from '@/utils/constants/revalidation'
import { capture404PageError } from '@/utils/functions/elk-server'
import {
  IndividualCaseStudyPageResponse,
  individualCaseStudyPageQuery
} from '@/utils/queries/individual-case-studies-page'
import { constructMetadataFromStrapiData } from '@/utils/functions/strapi'

function CaseStudyPage({
  page
}: InferGetStaticPropsType<typeof getStaticProps>): JSX.Element {
  return (
    <Layout
      title={page.seo.title}
      meta={constructMetadataFromStrapiData(page.seo)}
      canonical={`/case-study/${page.slug}/`}
    >
      <CaseStudyIndividualPages data={page} />
    </Layout>
  )
}

export const getStaticProps = async (context: GetStaticPropsContext) => {
  const { params } = context
  const slug = params?.slug?.toString() as string

  const result = await getStrapiGraphqlData<IndividualCaseStudyPageResponse>(
    individualCaseStudyPageQuery.loc?.source.body,
    { slug }
  )

  // if case study is not present, redirect to 404 page
  if (!result || result.page.data.length === 0) {
    capture404PageError(`/case-study/${slug}/`)
    return { notFound: true, revalidate: INSTANT_REVALIDATION }
  }

  return {
    props: {
      page: result.page.data[0].attributes
    },
    revalidate: TEN_MINS_REVALIDATION
  }
}

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking'
  }
}

export default CaseStudyPage
